export const MODE = {
    OVERLAY: 'overlay',
    PERSISTENT: 'persistent',
} as const;

export const SIZE = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    '2XL': '2xl',
} as const;

export const SIZE_WIDTH = {
    [SIZE.XS]: '20rem',
    [SIZE.SM]: '24rem',
    [SIZE.MD]: '28rem',
    [SIZE.LG]: '32rem',
    [SIZE.XL]: '36rem',
    [SIZE['2XL']]: '42rem',
} as const;

export const APP_PERSISTENT_CLASSES = [
    'transition-spacing',
    'duration-500',
    'ease-in-out',
    'pr-[var(--base-drawer-persistent-shift,0px)]',
];
